module.exports = __webpack_public_path__ + "img/Screenshot-14.bb100591.png";